const PracticeAnalysisQuestions = [
    "Rs",
    "Lt",
    "Ra",
    "Sap",
    "Rts",
    "Lts",
    "Ss",
    "Wap",
    "Rtw",
    "Ws",
    "Sc",
    "Cs"
]

export default PracticeAnalysisQuestions;